<div class="reset-password">
  <div class="container" cdkTrapFocus>
    <div class="row justify-content-center align-items-center">
      <div class="col-md-6">

        <div class="login-header text-center">
          <img src="assets/images/consumable-logo.png" alt="consumable logo" class="logo" width="270"/>
          <p>Welcome to Consumable network</p>
        </div>

        <div class="login-content">
          <mat-card class="p-5">
            <mat-card-header class="mb-2">
              <mat-card-title>
                <h4>Reset password</h4>
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <form #passwordForm="ngForm" class="d-flex flex-column">
                <mat-form-field class="mb-4"  floatLabel="always">
                  <input type="password"
                         matInput
                         name="newPassword"
                         [pattern]="regex"
                         placeholder="New password"
                         required
                         [(ngModel)]="password.newPassword"
                         (keyup.enter)="password.repeatPassword === password.newPassword
                         && passwordForm.valid && reset()"
                         class="mb10">
                  <mat-hint align="end">Min. 8 characters: number, special character, lowercase, uppercase and letters</mat-hint>
                </mat-form-field>
                <mat-form-field style="margin-bottom: -1rem;" floatLabel="always">
                  <input type="password"
                         matInput
                         name="repeatPassword"
                         [pattern]="regex"
                         placeholder="Repeat password"
                         required
                         [(ngModel)]="password.repeatPassword"
                         (keyup.enter)="password.repeatPassword === password.newPassword
                         && passwordForm.valid && reset()"
                         class="mb10">
                </mat-form-field>
              </form>
            </mat-card-content>
          </mat-card>

          <div class="box-controls text-center">
            <button type="button" mat-raised-button color="primary" class="large iconed" (click)="reset()"
                    [disabled]="!passwordForm.valid">
              <i class="far fa-envelope" aria-hidden="true"></i>
              Reset password
            </button>
          </div>

          <div class="box-controls text-center">
            <a mat-button color="primary" [routerLink]="'/login'">Back to sign in</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
